import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Notification from 'components/Notification';
import { componentsBranding } from 'constants/branding';
import { VALIDATION_ERROR_BET_INVALID_US_PRICE } from 'constants/placement';

type TInlineBetErrorProps = {
  message: string;
  onClose: () => void;
};
const InlineBetError = ({ message, onClose }: TInlineBetErrorProps) => {
  const { t } = useTranslation();
  const isPriceInfo = message == t(VALIDATION_ERROR_BET_INVALID_US_PRICE);
  return (
    <Notification
      type={isPriceInfo ? 'info' : 'warning'}
      message={message}
      className={classNames(componentsBranding.NOTIFICATION, { [componentsBranding.ERROR]: !isPriceInfo })}
      onClose={onClose}
      onClickOutside={onClose}
    />
  );
};

export default InlineBetError;
